import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { logoutUser } from '../../containers/Auth/auth.action';
import * as game from '../../controllers';
import globalRanking from '../../images/icon-classificacao-geral.png';
import localRanking from '../../images/icon-classificacao-local.png';
import Spinner from '../components/spinner';
import FacebookLogin from '../../utils/facebookLogin';
import errorCatcher from '../../utils/errorCatcher';
import { ACTIONS } from '../../actions/actionTypes';
import { DateTime } from '@app-masters/js-lib';

// Avatars
import userAvatar from '../../images/avatars/user.svg';
import studentManAvatar from '../../images/avatars/man/student.svg';
import graduateManAvatar from '../../images/avatars/man/graduate.svg';
import masterManAvatar from '../../images/avatars/man/master.svg';
import doctorManAvatar from '../../images/avatars/man/doctor.svg';
import teacherManAvatar from '../../images/avatars/man/teacher.svg';
import studentWomanAvatar from '../../images/avatars/woman/female_student.svg';
import graduateWomanAvatar from '../../images/avatars/woman/female_graduate.svg';
import masterWomanAvatar from '../../images/avatars/woman/female_master.svg';
import doctorWomanAvatar from '../../images/avatars/woman/female_doctor.svg';
import teacherWomanAvatar from '../../images/avatars/woman/female_teacher.svg';

// lib
import { Text } from '@app-masters/react-lib';

class Profile extends Component {
    constructor (props) {
        super(props);
        this.state = {
            user: null,
            rank: null,
            statistics: null
        };
    }

    componentDidMount () {
        // console.log('=== USER ===', this.props.user);
        this.setState({loadingRanking: true, loadingStatistics: true});
        if (this.props.match.params.id) {
            this.setState({loadingUser: true});
            let id = this.props.match.params.id;
            game.user.getById(id).then(response => {
                this.setState({user: response, loadingUser: false});
            }).catch((err) => errorCatcher(err));

            game.user.getRankingById(id).then(response => {
                this.setState({rank: response, loadingRanking: false});
            }).catch((err) => errorCatcher(err));

            game.user.getStatistic(id).then(response => {
                this.setState({statistics: response, loadingStatistics: false});
            }).catch((err) => errorCatcher(err));
        } else {
            game.user.getRankingById(this.props.user._id).then(response => {
                this.setState({rank: response, loadingRanking: false});
            }).catch((err) => errorCatcher(err));

            game.user.getStatistic(this.props.user._id).then(response => {
                this.setState({statistics: response, loadingStatistics: false});
            }).catch((err) => errorCatcher(err));
        }
    }

    welcomeMessage ({name, data}) {
        // console.log(name);
        return name;
    }

    renderLoading () {
        return (
            <div className='view-background profile-bg'>
                <Spinner />
            </div>
        );
    }

    getRanking (nivel) {
        let rank = this.state.rank;
        let data = [];
        if (rank) {
            let {positionGlobal, positionSchool} = rank;
            // console.log(positionGlobal, positionSchool, rank);
            if (nivel === 'general') {
                if (positionGlobal !== undefined) {
                    data.push(<h1 key='global-position'>{positionGlobal + '°'}</h1>);
                } else {
                    data.push(<h1 key='both-position'>{'>999°'}</h1>);
                }
            }
            if (nivel === 'local') {
                if (positionSchool !== undefined) {
                    data.push(<h1 key='local-position'>{positionSchool + '°'}</h1>);
                } else {
                    data.push(<h1 key='both-position'>{'>999°'}</h1>);
                }
            }
        }
        return data;
    }

    renderBarPercentage (percentage) {
        if (percentage > 100) {
            percentage = 0;
        }
        return (
            <div className='profile-progress'>
                <div
                    className='progress-bar'
                    style={{
                        width: `${percentage || 0}%`,
                        backgroundColor: `${percentage < 33 ? '#f44336' : percentage < 66 ? '#fc8900' : '#4caf50'}`
                    }} />
            </div>

        );
    }

    renderStats (user) {
        if (user.data.affinity && user.data.affinity.length > 1) {
            let percentage = user.data.affinity;
            percentage.sort((a, b) => {
                return b.percentage - a.percentage;
            });
            let minor = percentage.slice(-1)[0].percentage * 0.6;
            let high = percentage[0].percentage - minor;

            return user.data.affinity.map((item, index) => {
                item.percentage = ((item.percentage - minor) / high) * 0.94;
                return (
                    <div key={index}>
                        {item.areaTitle}{this.renderBarPercentage(item.percentage * 100)}
                    </div>
                );
            });
        } else {
            return <p>Jogue um pouco mais para que possamos identificar suas áreas de afinidade.</p>;
        }
    }

    renderBadges (user) {
        if (user) {
            if (user.data.badge && user.data.badge.length) {
                return user.data.badge.map((item, index) => {
                    return (
                        <div key={index} className='medal'>
                            <div className='image'>
                                <img src={item.image} />
                            </div>
                            <div className='info'>
                                <h3>{item.title}</h3>
                                <span>{item.description}</span>
                            </div>
                        </div>
                    );
                });
            } else {
                return (
                    <h3>Você ainda não possui medalhas. Continue se dedicando aos estudos!</h3>
                );
            }
        }
    }

    logout () {
        this.props.logoutUser();
        FacebookLogin.checkStatusAndLogout();
    }

    renderExitButton () {
        if (!this.props.match.params.id) {
            return (
                <div className='btn btn-profile-logout block' onClick={() => this.logout()}>
                    <h4>Sair do Jogo</h4>
                </div>
            );
        }
    }

    renderBackButton () {
        return (
            <div className='btn btn-profile block'
                 onClick={(!this.props.match.params.id) ? () => this.props.push('/') : () => this.props.push('/ranking')}>
                <h4>Voltar</h4>
            </div>
        );
    }

    renderRepeated (repeatCount) {
        let repeatedText = null;
        if (repeatCount) {
            repeatedText = repeatCount + ' ' + Text.singularOrPlural(repeatCount, 'período atrasado', 'perídodos atrasados');
        } else {
            repeatedText = 'Em dia com o período';
        }
        return <span>{repeatedText}</span>;
    }

    showAcademicRecords () {
        const userData = this.props.user.data;
        const {monitor, graduated, master, doctor} = userData.academicRecords;
        if ((userData.restartedStatus && userData.restartedStatus !== null) || monitor.length > 0 || graduated.length > 0 || master.length > 0 || doctor.length > 0) {
            return (
                <div className='box courses'>
                    <div className='outter-border'>
                        <div className='title'>HISTÓRICO</div>
                    </div>
                    <div className='box-bg'>
                        <div className='courses'>
                            <h2>{this.getRecords(this.props.user)}</h2>
                        </div>
                    </div>
                </div>);
        }
    }

    showFinishedStatus () {
        const userData = this.props.user.data;
        console.log('DATA', userData);
        if (userData.finishedGame) {
            return (
                <div className='box courses'>
                    <div className='outter-border'>
                        <div className='title'>FINALIZADO</div>
                    </div>
                    <div className='box-bg'>
                        <div className='courses'>
                            <h2>Finalizou o game em {DateTime.TSToDate(userData.finishedStatus.date)}, estava
                                com {userData.finishedStatus.points} pontos
                                na {userData.finishedStatus.positionGlobal}° posição do ranking global
                                e na {userData.finishedStatus.positionSchool}° posição do ranking de sua escola. </h2>
                        </div>
                    </div>
                </div>);
        }
    }

    getRecords (user) {
        return [
            user.data.restartedStatus
                ? <div>Começou novamente o jogo em {DateTime.TSToDate(user.data.restartedStatus.date)},
                    estava
                    com {user.data.restartedStatus.points} pontos
                    na {user.data.restartedStatus.positionGlobal}° posição do ranking global
                    e na {user.data.restartedStatus.positionSchool}° posição do ranking de sua
                    escola. </div>
                : null,
            user.data.academicRecords.monitor.map((item, index) => {
                console.log('ITEM', item);
                return (
                    <div key={index}>Foi monitor de {item.title}</div>
                );
            }),
            user.data.academicRecords.graduated.map((item, index) => {
                console.log('ITEM', item);
                return (
                    <div key={index}>Formou-se em {item.title}</div>
                );
            }),
            user.data.academicRecords.master.map((item, index) => {
                return (
                    <div key={index}>É mestre em {item.title}</div>
                );
            }),
            user.data.academicRecords.doctor.map((item, index) => {
                return (
                    <div key={index}>É doutor em {item.title}</div>
                );
            })
        ];
    }

    getAvatar (user) {
        let level = user.data.level.order;
        let gender = user.data.gender;
        if (gender.toUpperCase() === 'MASCULINO') {
            if (level < 5) {
                return studentManAvatar;
            } else if (level < 9) {
                return graduateManAvatar;
            } else if (level < 11) {
                return masterManAvatar;
            } else if (level < 13) {
                return doctorManAvatar;
            } else {
                return teacherManAvatar;
            }
        } else if (gender.toUpperCase() === 'FEMININO') {
            if (level < 5) {
                return studentWomanAvatar;
            } else if (level < 9) {
                return graduateWomanAvatar;
            } else if (level < 11) {
                return masterWomanAvatar;
            } else if (level < 13) {
                return doctorWomanAvatar;
            } else {
                return teacherWomanAvatar;
            }
        } else {
            return userAvatar;
        }
    }

    render () {
        if (this.state.loadingRanking || this.state.loadingStatistics || this.state.loadingUser) {
            return this.renderLoading();
        }
        const user = (this.state.user !== null) ? this.state.user : this.props.user;

        return (
            <div className='view-background profile-bg'>
                <div className='box'>
                    <div className='box-bg perfil'>
                        <div className='header'>
                            <div className='img-avatar'>
                                <img src={this.getAvatar(user)} />
                            </div>
                            <div className='info'>
                                <h2 className='name'>{Text.nameSurname(user.name)}</h2>
                                <span>{user.data.level.title}</span>
                                <span>Pontos: <span className='infoText'>{user.data.points}</span></span>
                            </div>
                        </div>
                        <div className='more-info'>
                            <span>{(user.data.school) ? user.data.school.name : ''}</span>
                            {(user.data.city)
                                ? <span>{user.data.city.title}</span>
                                : (user.data.otherCity)
                                    ? <span>{user.data.otherCity}</span>
                                    : null
                            }
                            {this.renderRepeated(user.data.repeatCount)}
                        </div>
                    </div>
                </div>

                <div className='box classification'>
                    <div className='outter-border'>
                        <div className='title'>CLASSIFICAÇÃO</div>
                    </div>
                    <div className='box-bg'>
                        <div className='ranking'>
                            <div>
                                <img src={globalRanking} />
                            </div>
                            <div>
                                <h3>GERAL</h3>
                                <span className='infoText'>{this.getRanking('general')}</span>
                            </div>
                        </div>
                        <div className='ranking'>
                            <div>
                                <img src={localRanking} />
                            </div>
                            <div>
                                <h3>{user.data.school ? user.data.school.name : 'ESCOLA'}</h3>
                                <span className='infoText'>{this.getRanking('local')}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='box classification'>
                    <div className='outter-border'>
                        <div className='title'>MEDALHAS</div>
                    </div>
                    <div className='box-bg'>
                        {this.renderBadges(user)}
                    </div>
                </div>

                <div className='box knowledge'>
                    <div className='outter-border'>
                        <div className='title'>ÁREAS DE CONHECIMENTO</div>
                    </div>
                    {<div className='box-bg'>
                        <div className='stats'>
                            <h2 style={{width: '100%'}}>{this.renderStats(user)}</h2>
                        </div>
                    </div>}
                </div>

                {this.showAcademicRecords()}
                {this.showFinishedStatus()}
                <div className='btn btn-profile block'
                     onClick={(!this.props.match.params.id) ? () => this.props.push('/') : () => this.props.push('/ranking')}>
                    <h4>Voltar</h4>
                </div>
                {/* <div className='btn btn-profile block' onClick={() => this.props.push('/share')}> */}
                {/* <h4>Compartilhar</h4> */}
                {/* </div> */}
                <div className='btn btn-profile block'
                     onClick={() => this.props.modalOpen()}>
                    <h4>Reiniciar o jogo</h4>
                </div>
                <div className='btn btn-profile-logout block' onClick={() => this.logout()}>
                    <h4>Sair do Jogo</h4>
                </div>
            </div>
        );
        // }
    }
}

const mapStateToProps = ({user}) => ({
    user: user.user
});

const mapDispatchToProps = (dispatch) => ({
    push: (location) => dispatch(push(location)),
    modalOpen: () => dispatch({
        type: ACTIONS.OPEN_PROFILE_MODAL
    }),
    logoutUser: () => dispatch(logoutUser())
});

export default connect(mapStateToProps, mapDispatchToProps)(Profile);



// WEBPACK FOOTER //
// ./src/views/UserViews/profileView.js